document.addEventListener("DOMContentLoaded", () => {
  // Every .tax-price-switcher on the page (header on desktop, top bar on mobile)
  // shares one state. The current state is also exposed as the "vat-incl" class
  // on <html> so other scripts (e.g. the header cart total) can read it.
  const switchers = document.querySelectorAll(".tax-price-switcher");

  if (!switchers.length) {
    console.warn("VAT switcher not found. Skipping price switcher initialization.");
    return;
  }

  let showInclVat = false;

  // --- Core function to update price visibility and switcher appearance ---
  const updatePriceVisibility = (inclVat) => {
    showInclVat = inclVat;
    document.documentElement.classList.toggle("vat-incl", inclVat);

    const pricesInclVat = document.querySelectorAll(
      ".vat-price-display.price-incl-vat"
    );
    const pricesExclVat = document.querySelectorAll(
      ".vat-price-display.price-excl-vat"
    );

    pricesInclVat.forEach((el) => (el.style.display = inclVat ? "inline" : "none"));
    pricesExclVat.forEach((el) => (el.style.display = inclVat ? "none" : "inline"));

    // Highlight the selected option in every switcher
    document.querySelectorAll(".tax-price-switcher [data-vat-choice]").forEach((button) => {
      const isActive = (button.dataset.vatChoice === "incl") === inclVat;
      button.classList.toggle("active", isActive);
      button.setAttribute("aria-pressed", isActive);
    });
  };

  // --- Load preference from local storage on page load ---
  // If no preference is saved, default to VAT Excl.
  const savedPreference = localStorage.getItem("showPricesInclVat");
  updatePriceVisibility(savedPreference === "true");

  // --- Switcher clicks ---
  document.addEventListener("click", (event) => {
    const button = event.target.closest(".tax-price-switcher [data-vat-choice]");
    if (!button) {
      return;
    }

    const inclVat = button.dataset.vatChoice === "incl";
    updatePriceVisibility(inclVat);
    localStorage.setItem("showPricesInclVat", inclVat);
  });

  // --- Handle dynamically added prices (variant changes, collection filters,
  // infinite scroll, quick view, predictive search) ---
  // New prices arrive with the server default (VAT Excl.), so re-apply the
  // current state whenever price elements are added anywhere on the page.
  const observePriceChanges = () => {
    const observer = new MutationObserver((mutationsList) => {
      const vatPriceElementsAdded = mutationsList.some((mutation) =>
        Array.from(mutation.addedNodes).some(
          (node) =>
            node.nodeType === 1 &&
            (node.matches(".vat-price-display") ||
              node.querySelector(".vat-price-display") ||
              node.closest(".vat-price-display"))
        )
      );

      if (vatPriceElementsAdded) {
        updatePriceVisibility(showInclVat);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  // Initialize observer for existing price elements
  observePriceChanges();
});
